import api from "../api";
import ApiConstant from "../../constants/api.constants";

const getVehicles = async (request: any) => {
    try {
        const response: any = await api
            .post(ApiConstant.GetAllVehicles, request)
            .then((result: any) => {
                if (result) return result.data;
                else return null;
            })
            .catch((error: any) => {
                console.error("Error fetching vehicle list.", error);
            });

        return response ?? { data: [], totalRecords: 0, page: 1, pageSize: 10 };
    } catch (e) {
        console.log("error in getVehicles");
        return { data: [], totalRecords: 0, page: 1, pageSize: 10 };
    }
};

const addVehicle = async (vehicleData: any) => {
    try {
        const response = await api.post(
            ApiConstant.saveVehicle, vehicleData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error saving vehicle:", error);
        throw error;
    }
};

const getVehicleTypes = async (keyword: string | null) => {
    try {
        const payload = { keyword: keyword ?? "" };

        const response = await api.post(
            ApiConstant.getVehicleTypes,
            payload,
            { headers: { "Content-Type": "application/json" } }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching vehicle types:", error);
        return [];
    }
};

const getVehicleById = async (id: number) => {
    try {
        const response = await api.get(ApiConstant.getVehicleById, { params: { id } });
        return response.data;
    } catch (error) {
        console.error("Error fetching vehicle by ID:", error);
        return null;
    }
};

const updateVehicle = async (vehicleData: any) => {
    try {
        const response = await api.post(ApiConstant.updateVehicle, vehicleData);

        return response.data;
    } catch (error: any) {
        console.error("Error updating vehicle:", error);
        return null;
    };
}

const updateVehicleStatus = async (id: number, status: boolean) => {
    try {
        const response = await api.post(
            `${ApiConstant.updateVehicleStatus}?id=${id}&status=${status}`
        );

        return response.data;
    } catch (err: any) {
        return null;
    }
};

const getPOSList = async (keyword: string | null) => {
  try{
  const response = await api.post(ApiConstant.getPOSList, {
    keyword: keyword ?? ""
  });
  return response.data;
}catch (err: any) {
        return null;
    }
};

const getVehicleDropdown = async (request: any) => {
    try {
        const response: any = await api
            .post(ApiConstant.GetVehicleDropdown, request)
            .then((result: any) => {
                if (result) return result;
                else return [];
            })
            .catch((error: any) => {
                console.error("Error fetching vehicle dropdown list.", error);
            });

        return response ?? [];
    } catch (e) {
        console.log("error in getVehicleDropdown");
        return [];
    }
};


const vehicleService = {
    getVehicles,
    addVehicle,
    getVehicleTypes,
    getVehicleById,
    updateVehicle,
    updateVehicleStatus,
    getPOSList,
    getVehicleDropdown,
};

export default vehicleService;